export const SAVE_APPOINTMENT_REPORT = "SAVE_APPOINTMENT_REPORT"
export const SAVE_APPOINTMENT_REPORT_FAIL = "SAVE_APPOINTMENT_REPORT_FAIL"
export const SAVE_APPOINTMENT_REPORT_SUCCESS = "SAVE_APPOINTMENT_REPORT_SUCCESS"
export const SAVE_APPOINTMENT_REPORT_RESET = "SAVE_APPOINTMENT_REPORT_RESET"

export const saveAppointmentReport = (params) => {
    return { type: SAVE_APPOINTMENT_REPORT, params }
}
export const saveAppointmentReportFail = (response) => {
    return { type: SAVE_APPOINTMENT_REPORT_FAIL, response }
}
export const saveAppointmentReportSuccess = (response) => {
    return { type: SAVE_APPOINTMENT_REPORT_SUCCESS, response }
}
export const saveAppointmentReportReset = () => {
    return { type: SAVE_APPOINTMENT_REPORT_RESET }
}